import { Account } from '@/models/account.model';
import { useGetAccountByNameQuery } from '@/services/api/account.api';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

type CurrentAccountHookReturn<A> = {
  currentAccount: A;
  isLoading: boolean;
  getAccountLink: (path?: string) => string;
};

export const useCurrentAccount = <
  A = Account
>(): CurrentAccountHookReturn<A> => {
  const { accountName } = useParams<{ accountName?: string }>();

  const { data: currentAccount, isLoading } = useGetAccountByNameQuery(
    { accountName: accountName! },
    { skip: !accountName }
  );

  const getAccountLink = useCallback(
    (path?: string) => {
      if (!currentAccount) {
        return path || '';
      }

      const prefix = `/a/${currentAccount.name}`;

      if (!path) {
        return prefix;
      }

      return path.startsWith('/') ? `${prefix}${path}` : `${prefix}/${path}`;
    },
    [currentAccount]
  );

  return {
    currentAccount: currentAccount as A,
    getAccountLink,
    isLoading
  };
};
